export default "__VITE_ASSET__bVirZ$uK__"